// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=Cutive+Mono&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=Cutive+Mono&family=Raleway:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=Cutive+Mono&family=Raleway:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=Cutive+Mono&family=Inknut+Antiqua:wght@300;400;500;600;700;800;900&family=Raleway:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Averia+Serif+Libre:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=Cutive+Mono&family=Inknut+Antiqua:wght@300;400;500;600;700;800;900&family=Raleway:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @font-face {
    font-family: 'futura';
    src: url('../assets/fonts/futura/Futura\\ Heavy\\ font.ttf')
}
@font-face {
    font-family: 'futura-light';
    src: url('../assets/fonts/futura/futura\\ medium\\ bt.ttf')
} */

/* internal-styles */
html {
    font-size: 18px;
    color: #3C3B3B;
}

body {
    line-height: 2rem;
    font-family: 'Cutive Mono', monospace;  
    font-family: 'Source Code Pro', monospace;
    font-family: 'Inknut Antiqua', serif;
    font-family: 'Averia Serif Libre', cursive;
    font-family: 'Roboto', sans-serif;
    font-family: 'Raleway', sans-serif;
    font-family: 'Courier Prime', monospace;
    
    /* font-family: 'Georgia'; */
    /* font-family: 'futura-light'; */
    color: #3C3B3B;
}

h2 {
    font-size: 1.25rem;
}

h2, h4, h3, h1 {
    font-family: 'futura-light', 'futura';
    /* font-family: 'futura'; */

}


@media only screen and (max-width: 1800px) {
    html {
        font-size: 12px;
    }

    div, p, button {
        font-size: 1.5rem;
    }
}

@media only screen and (max-width: 1500px) {
    html {
        font-size: 12px;
    }
    div, p, button {
        font-size: 1.5rem;
    }
}
#root{
    min-height: 100vh;
    min-width: 100vw;
}

p, div, span {
    -ms-overflow-style: none;  
    scrollbar-width: none; 
    white-space: pre-line;
    &::-webkit-scrollbar {
        display: none;
    }
}

textarea {
    padding: 1rem;
    font-family: Roboto, Helvetica, Arial, sans-serif;
    font-size: 1rem;
    font-weight: 500;
    border-radius: 1rem;
}

p {
    line-break: pre-line;
    text-wrap: pretty;
    margin-block-start: 0rem;
    margin-block-end: 0rem;
}

.chevron-down-container {
    box-sizing: border-box;
    position: relative;
    display: block;
    width: 1rem;
    height: 1rem;
    border: 2px solid transparent;
    color: #808080e6;
    cursor: pointer;
    &::after{
        content: "";
        display: block;
        box-sizing: border-box;
        width: 10px;
        height: 10px;
        border-bottom: 2px solid;
        border-right: 2px solid;
        transform: rotate(45deg);
    }
}

.chevron-up-container {
    box-sizing: border-box;
    position: relative;
    display: block;
    width: 1rem;
    height: 1rem;
    border: 2px solid transparent;
    color: #808080e6;
    cursor: pointer;
    &::after{
        content: "";
        display: block;
        box-sizing: border-box;
        width: 10px;
        height: 10px;
        border-bottom: 2px solid;
        border-right: 2px solid;
        transform: rotate(225deg);
    }
}


.chevron-left-container {
    box-sizing: border-box;
    position: relative;
    display: block;
    width: 1rem;
    height: 1rem;
    border: 2px solid transparent;
    color: #808080e6;
    cursor: pointer;
    &::after{
        content: "";
        display: block;
        box-sizing: border-box;
        width: 10px;
        height: 10px;
        border-bottom: 2px solid;
        border-right: 2px solid;
        transform: rotate(135deg);
    }
}

.chevron-right-container {
    box-sizing: border-box;
    position: relative;
    display: block;
    width: 1rem;
    height: 1rem;
    border: 2px solid transparent;
    color: #808080e6;
    cursor: pointer;
    &::after{
        content: "";
        display: block;
        box-sizing: border-box;
        width: 10px;
        height: 10px;
        border-bottom: 2px solid;
        border-right: 2px solid;
        transform: rotate(-45deg);
    }
}

.close-container {
    &::after {
        content: "\\00d7";
        font-size: 1.8rem;
        color: #808080e6;
        cursor: pointer;
        transition: 0.5s all;
    }
}

/* external-styles */
.MuiButton-text.MuiButtonBase-root  {
    text-transform: unset; 
}

.MuiInputBase-root.MuiOutlinedInput-root {
    border-radius: 1rem;
}

.MuiInputBase-root.Mui-focused  fieldset.MuiOutlinedInput-notchedOutline {
    border-color: #72ababb8;
}

textarea:focus {
    border-color: #72ababb8;
    outline-color: #72ababb8;
}`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/ui-kit.css"],"names":[],"mappings":"AAQA;;;;;;;GAOG;;AAEH,oBAAoB;AACpB;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,yCAAyC;IACzC,oCAAoC;IACpC,0CAA0C;IAC1C,iCAAiC;IACjC,kCAAkC;IAClC,uCAAuC;;IAEvC,4BAA4B;IAC5B,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;;AAE/B;;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,qBAAqB;IACrB;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,iDAAiD;IACjD,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf;QACI,WAAW;QACX,cAAc;QACd,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,wBAAwB;QACxB,uBAAuB;QACvB,wBAAwB;IAC5B;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf;QACI,WAAW;QACX,cAAc;QACd,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,wBAAwB;QACxB,uBAAuB;QACvB,yBAAyB;IAC7B;AACJ;;;AAGA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf;QACI,WAAW;QACX,cAAc;QACd,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,wBAAwB;QACxB,uBAAuB;QACvB,yBAAyB;IAC7B;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf;QACI,WAAW;QACX,cAAc;QACd,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,wBAAwB;QACxB,uBAAuB;QACvB,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,eAAe;QACf,oBAAoB;IACxB;AACJ;;AAEA,oBAAoB;AACpB;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=Cutive+Mono&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=Cutive+Mono&family=Raleway:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=Cutive+Mono&family=Raleway:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=Cutive+Mono&family=Inknut+Antiqua:wght@300;400;500;600;700;800;900&family=Raleway:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Averia+Serif+Libre:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=Cutive+Mono&family=Inknut+Antiqua:wght@300;400;500;600;700;800;900&family=Raleway:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&display=swap');\n\n/* @font-face {\n    font-family: 'futura';\n    src: url('../assets/fonts/futura/Futura\\ Heavy\\ font.ttf')\n}\n@font-face {\n    font-family: 'futura-light';\n    src: url('../assets/fonts/futura/futura\\ medium\\ bt.ttf')\n} */\n\n/* internal-styles */\nhtml {\n    font-size: 18px;\n    color: #3C3B3B;\n}\n\nbody {\n    line-height: 2rem;\n    font-family: 'Cutive Mono', monospace;  \n    font-family: 'Source Code Pro', monospace;\n    font-family: 'Inknut Antiqua', serif;\n    font-family: 'Averia Serif Libre', cursive;\n    font-family: 'Roboto', sans-serif;\n    font-family: 'Raleway', sans-serif;\n    font-family: 'Courier Prime', monospace;\n    \n    /* font-family: 'Georgia'; */\n    /* font-family: 'futura-light'; */\n    color: #3C3B3B;\n}\n\nh2 {\n    font-size: 1.25rem;\n}\n\nh2, h4, h3, h1 {\n    font-family: 'futura-light', 'futura';\n    /* font-family: 'futura'; */\n\n}\n\n\n@media only screen and (max-width: 1800px) {\n    html {\n        font-size: 12px;\n    }\n\n    div, p, button {\n        font-size: 1.5rem;\n    }\n}\n\n@media only screen and (max-width: 1500px) {\n    html {\n        font-size: 12px;\n    }\n    div, p, button {\n        font-size: 1.5rem;\n    }\n}\n#root{\n    min-height: 100vh;\n    min-width: 100vw;\n}\n\np, div, span {\n    -ms-overflow-style: none;  \n    scrollbar-width: none; \n    white-space: pre-line;\n    &::-webkit-scrollbar {\n        display: none;\n    }\n}\n\ntextarea {\n    padding: 1rem;\n    font-family: Roboto, Helvetica, Arial, sans-serif;\n    font-size: 1rem;\n    font-weight: 500;\n    border-radius: 1rem;\n}\n\np {\n    line-break: pre-line;\n    text-wrap: pretty;\n    margin-block-start: 0rem;\n    margin-block-end: 0rem;\n}\n\n.chevron-down-container {\n    box-sizing: border-box;\n    position: relative;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n    border: 2px solid transparent;\n    color: #808080e6;\n    cursor: pointer;\n    &::after{\n        content: \"\";\n        display: block;\n        box-sizing: border-box;\n        width: 10px;\n        height: 10px;\n        border-bottom: 2px solid;\n        border-right: 2px solid;\n        transform: rotate(45deg);\n    }\n}\n\n.chevron-up-container {\n    box-sizing: border-box;\n    position: relative;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n    border: 2px solid transparent;\n    color: #808080e6;\n    cursor: pointer;\n    &::after{\n        content: \"\";\n        display: block;\n        box-sizing: border-box;\n        width: 10px;\n        height: 10px;\n        border-bottom: 2px solid;\n        border-right: 2px solid;\n        transform: rotate(225deg);\n    }\n}\n\n\n.chevron-left-container {\n    box-sizing: border-box;\n    position: relative;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n    border: 2px solid transparent;\n    color: #808080e6;\n    cursor: pointer;\n    &::after{\n        content: \"\";\n        display: block;\n        box-sizing: border-box;\n        width: 10px;\n        height: 10px;\n        border-bottom: 2px solid;\n        border-right: 2px solid;\n        transform: rotate(135deg);\n    }\n}\n\n.chevron-right-container {\n    box-sizing: border-box;\n    position: relative;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n    border: 2px solid transparent;\n    color: #808080e6;\n    cursor: pointer;\n    &::after{\n        content: \"\";\n        display: block;\n        box-sizing: border-box;\n        width: 10px;\n        height: 10px;\n        border-bottom: 2px solid;\n        border-right: 2px solid;\n        transform: rotate(-45deg);\n    }\n}\n\n.close-container {\n    &::after {\n        content: \"\\00d7\";\n        font-size: 1.8rem;\n        color: #808080e6;\n        cursor: pointer;\n        transition: 0.5s all;\n    }\n}\n\n/* external-styles */\n.MuiButton-text.MuiButtonBase-root  {\n    text-transform: unset; \n}\n\n.MuiInputBase-root.MuiOutlinedInput-root {\n    border-radius: 1rem;\n}\n\n.MuiInputBase-root.Mui-focused  fieldset.MuiOutlinedInput-notchedOutline {\n    border-color: #72ababb8;\n}\n\ntextarea:focus {\n    border-color: #72ababb8;\n    outline-color: #72ababb8;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
